import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`

    /* Course Details */
    .course-details-area {
        background-color: #F6F9FF;
        padding: 70px 0 78px;

        .course-details-top {
            .heading {
                h4 {
                    color: ${colors.black1};
                    font-weight: 600;
                    line-height: 35px;
                    margin-bottom: 25px;

                    @media(max-width: 575px) {
                        font-size: 20px;
                    }
                }
            }

            .course-top-overview {
                margin-bottom: 25px;
                .overviews {
                    .author {
                        margin-right: 20px;
                        padding-right: 20px;
                        margin-top: -3px;
                        border-right: 1px solid ${colors.border3};

                        img {
                            float: left;
                            max-width: 50px;
                            border-radius: 50%;
                            margin-right: 10px;
                        }

                        .author-name {
                            float: left;
                            margin-top: 3px;

                            h6 {
                                color: ${colors.black2};
                                font-weight: 600;
                                text-transform: uppercase;
                                margin-bottom: 5px;

                                @media(max-width: 767px) {
                                    font-size: 14px;
                                }
                            }

                            p {
                                font-size: 13px;
                                color: ${colors.text3};
                                font-weight: 500;

                                @media(max-width: 767px) {
                                    font-size: 12px;
                                }
                            }
                        }
                    }

                    .category {
                        margin-right: 20px;
                        padding-right: 20px;
                        border-right: 1px solid ${colors.border3};

                        h6 {
                            color: ${colors.black2};
                            font-weight: 600;
                            text-transform: uppercase;
                            margin-bottom: 5px;

                            @media(max-width: 767px) {
                                font-size: 14px;
                            }
                        }

                        p {
                            font-size: 13px;
                            color: #666666;
                            font-weight: 500;

                            @media(max-width: 767px) {
                                font-size: 12px;
                            }
                        }
                    }

                    .rating {
                        margin-right: 20px;
                        padding-right: 20px;
                        border-right: 1px solid ${colors.border3};

                        h6 {
                            color: ${colors.black2};
                            font-weight: 600;
                            text-transform: uppercase;
                            margin-bottom: 5px;

                            @media(max-width: 767px) {
                                font-size: 14px;
                            }
                        }

                        ul {
                            li {
                                margin-right: 1px;

                                i {
                                    font-size: 16px;
                                    color: ${colors.yellow};
                                }

                                &:last-child {
                                    font-size: 13px;
                                    color: ${colors.text3};
                                }
                            }
                        }
                    }

                    .price {
                        h6 {
                            color: ${colors.black2};
                            font-weight: 600;
                            text-transform: uppercase;
                            margin-bottom: 5px;

                            @media(max-width: 767px) {
                                font-size: 14px;
                            }
                        }

                        p {
                            font-size: 13px;
                            color: #666666;
                            font-weight: 500;

                            @media(max-width: 767px) {
                                font-size: 12px;
                            }
                        }
                    }
                }
            }

            .course-details-banner {
                margin-bottom: 40px;

                img {
                    border-radius: 5px;
                }
            }

            .course-tab-list {
                .nav {
                    display: inline-block;
                    border-radius: 5px;
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
                    margin-bottom: 35px;

                    .nav-item {
                        display: inline-block;

                        a.nav-link {
                            font-size: 14px;
                            color: ${colors.black2};
                            font-weight: 500;
                            text-transform: uppercase;
                            padding: 12px 30px 10px;
                            border-radius: 5px;

                            @media(max-width: 991px) {
                                padding: 12px 16px 9px;
                            }
                        }

                        a.nav-link.active {
                            background: ${colors.gr_bg};
                            color: #ffffff;
                        }
                    }
                }

                .tab-content .overview-tab {
                    h4 {
                        color: ${colors.black2};
                        font-weight: 600;
                        padding-bottom: 10px;
                        margin-bottom: 20px;
                        position: relative;

                        @media(max-width: 575px) {
                            font-size: 17px;
                        }
                    }

                    p {
                        font-size: 13px;
                        color: #666666;
                        line-height: 25px;

                        @media(max-width: 575px) {
                            font-size: 12px;
                        }
                    }

                    .course-desc {
                        margin-bottom: 40px;
                    }

                    .course-feature {
                        margin-bottom: 40px;

                        ul {
                            margin-top: 20px;

                            li {
                                font-size: 14px;
                                color: ${colors.text3};
                                line-height: 25px;
                                margin-bottom: 10px;

                                i {
                                    font-size: 20px;
                                    color: ${colors.green};
                                    float: left;
                                    height: 40px;
                                    line-height: 27px;
                                    margin-right: 10px;
                                }

                                &:last-child {
                                    margin-bottom: 0;
                                }
                            }
                        }
                    }

                    .course-learn {
                        margin-bottom: 40px;

                        ul {
                            margin-top: 20px;

                            li {
                                font-size: 14px;
                                color: ${colors.text3};
                                line-height: 25px;
                                margin-bottom: 15px;

                                i {
                                    float: left;
                                    color: ${colors.green};
                                    border: 1px solid ${colors.border3};
                                    width: 35px;
                                    height: 35px;
                                    border-radius: 50%;
                                    text-align: center;
                                    padding-top: 9px;
                                    //margin-top: 8px;
                                    margin-right: 15px;
                                }

                                span {
                                    font-weight: bold;
                                    color: #5e5e5e;
                                }

                                &:last-child {
                                    margin-bottom: 0;
                                }
                            }
                        }
                    }

                    .course-share {
                        ul.social {
                            margin-top: 30px;

                            li {
                                a {
                                    text-align: center;
                                    position: relative;
                                    height: 18px;
                                    display: inline-block;

                                    &:before {
                                        content: "";
                                        position: absolute;
                                        border-width: 9px 17px;
                                        border-style: solid;
                                        border-top-color: transparent;
                                        border-right-color: transparent;
                                        border-left-color: transparent;
                                        top: -18px;
                                        left: 0;
                                        z-index: 1;
                                        transition: all 0.2s ease;
                                    }

                                    &:after {
                                        content: "";
                                        position: absolute;
                                        border-width: 9px 17px;
                                        border-style: solid;
                                        border-right-color: transparent;
                                        border-bottom-color: transparent;
                                        border-left-color: transparent;
                                        bottom: -18px;
                                        left: 0;
                                        z-index: 1;
                                        transition: all 0.2s ease;
                                    }

                                    i {
                                        font-size: 14px;
                                        color: #ffffff;
                                        width: 34px;
                                    }

                                    &:hover {
                                        background-color: ${colors.green} !important;

                                        &:before {
                                            border-bottom-color: ${colors.green} !important;
                                        }

                                        &:after {
                                            border-top-color: ${colors.green} !important;
                                        }
                                    }
                                }

                                &:nth-child(1) {
                                    a {
                                        background-color: #4267B2;

                                        &:before {
                                            border-bottom-color: #4267B2;
                                        }

                                        &:after {
                                            border-top-color: #4267B2;
                                        }
                                    }
                                }

                                &:nth-child(2) {
                                    a {
                                        background-color: #1DA1F2;

                                        &:before {
                                            border-bottom-color: #1DA1F2;
                                        }

                                        &:after {
                                            border-top-color: #1DA1F2;
                                        }
                                    }
                                }

                                &:nth-child(3) {
                                    a {
                                        background-color: #2867B2;

                                        &:before {
                                            border-bottom-color: #2867B2;
                                        }

                                        &:after {
                                            border-top-color: #2867B2;
                                        }
                                    }
                                }

                                &:nth-child(4) {
                                    a {
                                        background-color: #DD1343;

                                        &:before {
                                            border-bottom-color: #DD1343;
                                        }

                                        &:after {
                                            border-top-color: #DD1343;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;